import JSEncrypt from "jsencrypt";
import CryptoJS from "crypto-js";

// RSA加密
function getRsaCode(str) {
  // 注册方法
  let pubKey = `MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCttMz3mwVDHJldIOIo/eeW4THA
    PNjxXHMN/I4E6gt3im3Zf6qS7iGCB7LKEUGSOl1LK89i1LE9GCxCUBq+9OofonnB
    6K126XmFwMZw4gXMqOJzdf4Ad/Chd5r+0gFiNc51GAyTl/f2LVHSL/PnmEzgIk2h
    rZ/edrR8jvBMHfLbsQIDAQAB`; // ES6 模板字符串 引用 rsa 公钥
  let encryptStr = new JSEncrypt();
  encryptStr.setPublicKey(pubKey); // 设置 加密公钥
  let rsaData = encryptStr.encrypt(str.toString()); // 进行加密
  return rsaData;
}
// AES加密
function getAesCode(word, keyStr) {
  let srcs = CryptoJS.enc.Utf8.parse(word);
  let key = CryptoJS.enc.Utf8.parse(keyStr);
  var encrypted = CryptoJS.AES.encrypt(srcs, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });
  return window.btoa(CryptoJS.enc.Base64.stringify(encrypted.ciphertext));
}

export default {
  getRsaCode,
  getAesCode,
};
